import RouteIcon from "@mui/icons-material/Route";
import DailyOpsView from "./DailyOpsView";

export default {
  list: DailyOpsView,
  icon: RouteIcon,
  label: "Today's route",
  options: { label: "Today's route" },
  name: "houseVisitDaily",
};
